import { legacyApiAuth } from '../../apis'
import type {
  IApiResponseNotification,
  IResponseService,
  IServiceNotification
} from '../../interfaces'
import { convertSnakeCaseToCamelCase } from '../utils/formatterResponse'

export const getNotifications = async ({
  userId,
  page,
  limit
}: {
  userId: string
  page: number
  limit: number
}): Promise<IResponseService<IServiceNotification>> => {
  try {
    const response = await legacyApiAuth.get<IApiResponseNotification>(
      `/v2.0.2/wall/user/${userId}/notifications`,
      {
        params: {
          p: page,
          l: limit
        }
      }
    )

    const enrichedNotifications = response?.notifications?.map(
      (notification) => {
        const parsedMetadata = JSON.parse(notification?.metadata)
        const camelMetadata = convertSnakeCaseToCamelCase(parsedMetadata)

        return {
          ...notification,
          metadata: camelMetadata
        }
      }
    )

    return {
      isSuccess: true,
      data: {
        ...response,
        notifications: enrichedNotifications
      }
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const patchRemoveCountNotifications = async ({
  userId
}: {
  userId: string
}) => {
  try {
    await legacyApiAuth.patch(`/v2.0.2/wall/user/${userId}/remove_count`, {})
    return {
      isSuccess: true
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const patchMarkAsReadNotification = async ({
  userId,
  notificationId
}: {
  userId: string
  notificationId: string
}) => {
  try {
    await legacyApiAuth.patch(
      `/v2.0.2/wall/user/${userId}/${notificationId}/check`,
      {}
    )
    return {
      isSuccess: true
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}
